import createIcon from '../../createIcon';

/**
 * @component @name KeyboardTab
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDkgNy40MUwxNS42NyAxMUgxLjVWMTNIMTUuNjdMMTIuMDggMTYuNTlMMTMuNSAxOEwxOS41IDEyTDEzLjUgNkwxMi4wOSA3LjQxWk0yMC41IDZWMThIMjIuNVY2SDIwLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardTab = createIcon('KeyboardTab', [
  [
    'path',
    {
      d: 'M12.09 7.41L15.67 11H1.5V13H15.67L12.08 16.59L13.5 18L19.5 12L13.5 6L12.09 7.41ZM20.5 6V18H22.5V6H20.5Z',
      key: '1ciu98',
    },
  ],
]);

export default KeyboardTab;
